import { Link } from 'react-router-dom';
import { Home, Compass } from 'lucide-react';
import { Button } from '@/components/ui';

/**
 * A page that does not exist, saying so.
 *
 * Replaces a redirect to the home page. That redirect was fine for a person
 * and bad for everything else: Netlify's SPA fallback answers 200 for every
 * unknown path, so a mistyped or long-dead link served the home page, with a
 * success status, at a URL that was not the home page — which is how a site
 * accumulates hundreds of indexed duplicates of its own front door.
 *
 * The route carries a noindex (see useRouteSeo), which is the part that
 * actually works, since the status code cannot be changed without giving up
 * the SPA fallback that makes every other route load on refresh.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-5">
      <div className="text-center max-w-md">
        <div className="h-14 w-14 rounded-2xl bg-raised border border-line flex items-center
                        justify-center text-faint mx-auto mb-5">
          <Compass className="h-6 w-6" />
        </div>
        <h1 className="text-title">This page does not exist</h1>
        <p className="text-muted mt-3 leading-relaxed">
          The link may be out of date, or there may be a typo in the address.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-7">
          <Link to="/">
            <Button variant="primary" icon={<Home className="h-4 w-4" />}>
              Back to the start
            </Button>
          </Link>
          <Link to="/tour">
            <Button variant="outline">See what PROVIA does</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
